// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { invoiceDetailSchema } from '@/billing/api/types';
import { z } from 'zod';

const voidInvoiceResponseSchema = z.object({
  data: invoiceDetailSchema,
  metadata: responseMetadataSchema,
});

export interface VoidInvoiceInput {
  invoiceKey: string;
  voidReason: string | null;
}

export async function voidInvoice(input: VoidInvoiceInput) {
  const url = `/v1/invoice/${input.invoiceKey}/void`;
  const response = await api.post(url, { voidReason: input.voidReason });

  const result = await parseResponse(voidInvoiceResponseSchema, response.data, {
    schemaName: 'VoidInvoice',
    endpoint: url,
  });
  return result.data;
}
